// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_root__HUGDd {
  padding: 25px 0;
  width: 100%;
  background-color: var(--color-bg-header);
  color: var(--color-font-10);
  height: 40px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  border: 1px solid var(--color-theme-cloud);
  align-items: center;
}

.Header_logo__8Ki-h {
  width: 180px;
  font-size: 27px;
  font-weight: 900;
  padding: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/@_pages/Layout/Header/Header.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,wCAAwC;EACxC,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf","sourcesContent":[".root {\n  padding: 25px 0;\n  width: 100%;\n  background-color: var(--color-bg-header);\n  color: var(--color-font-10);\n  height: 40px;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 100;\n  display: flex;\n  border: 1px solid var(--color-theme-cloud);\n  align-items: center;\n}\n\n.logo {\n  width: 180px;\n  font-size: 27px;\n  font-weight: 900;\n  padding: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Header_root__HUGDd`,
	"logo": `Header_logo__8Ki-h`
};
export default ___CSS_LOADER_EXPORT___;
